import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import { ThemeOverride, ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import VerificationResent from './VerificationResent';
import VerificationNeeded from './VerificationNeeded';
export const VerificationReminder = ({ email , isUnverified , resendEmail , isEmailChangeInProgress , isResendInProgress , isSendingDone , hideChangeEmail  })=>{
    return /*#__PURE__*/ React.createElement(ThemeOverride, {
        theme: ThemeOptions.LIGHT
    }, isSendingDone ? /*#__PURE__*/ React.createElement(VerificationResent, {
        email: email
    }) : /*#__PURE__*/ React.createElement(VerificationNeeded, _extends({}, {
        email,
        isUnverified,
        resendEmail,
        isEmailChangeInProgress,
        isResendInProgress,
        hideChangeEmail
    })));
};
VerificationReminder.displayName = 'VerificationReminder';
export default VerificationReminder;
